import { Injectable } from '@angular/core';
import { Level } from '../models/ScoresResponse';

@Injectable({
    providedIn: 'root',
})
export class ScoreService {
    constructor() {}

    getNextLevel(progress: Level[]): Level | null {
        if (progress.includes(Level.diamant)) {
            return null;
        } else if (progress.includes(Level.or)) {
            return Level.diamant;
        } else if (progress.includes(Level.argent)) {
            return Level.or;
        } else if (progress.includes(Level.bronze)) {
            return Level.argent;
        } else if (progress.includes(Level.bois)) {
            return Level.bronze;
        }

        return null;
    }
}
